export default __webpack_public_path__ + "static/media/vid-holder-red-light-district.b96cb22a.png";